import React from 'react';

import { Icon } from '../../icon/icon';

type Props = {
  className?: string;
};

const BlockIcon = (props: Props) => {
  return <Icon className={props.className} fixedWidth={true} icon={['fad', 'ban']} />;
};

export { BlockIcon };
